<div class="container-fluid">
    <div class="row">
  
   
  
      <div class="col" style="margin:20px;">
        <div class="card footprint">
            <div class="alert alert-danger" role="alert" *ngIf="tech_footprint_data_loading_failed">
              <h3>Tech Footprint Over Time</h3>
    
              <p>
                Unfortunately, we weren't able to load the data. Please try again later, or for more assistance, please
                contact
                <a href="mailto:tech@quant-ip.com" style="color: blue">info&#64;quant-ip.com</a>.
              </p>
            </div>
            
            <div class="alert alert-info" role="alert" role="alert" *ngIf="showTechFootprintNoDataFound">
              <h3>Tech Footprint Over Time</h3>
              <p>
                No technology footprint data found in the search for this time period.
               </p>
            </div>
            
            <div class="spinner-border text-primary" role="status"
              *ngIf="techFootprintData.length==0 && !tech_footprint_data_loading_failed && !showTechFootprintNoDataFound">
              <span class="visually-hidden">Loading...</span>
            </div>
            <div *ngIf="showTechnologyFootprint">
              <plotly-plot [data]="techFootprintGraph.data" [layout]="techFootprintGraph.layout"></plotly-plot>
            </div>
          </div>
  
      </div>
      <div class="col" style="margin:20px;">
  
        <div class="card footprint">
          <div class="alert alert-danger" role="alert" *ngIf="clusters_footprint_data_loading_failed">
            <h3>Cluster Footprint Over Time</h3>
  
            <p>
              Unfortunately, we weren't able to load the data. Please try again later, or for more assistance, please
              contact
              <a href="mailto:tech@quant-ip.com" style="color: blue">info&#64;quant-ip.com</a>.
            </p>
          </div>
          
          <div class="alert alert-info" role="alert" role="alert" *ngIf="showClusteringNoDataFound">
            <h3>Cluster Footprint Over Time</h3>
            <p>
              No cluster footprint data found in the search for this time period.
               </p>
          </div>
          
          <div class="spinner-border text-primary" role="status"
            *ngIf="clusterFootprintData.length==0 && !clusters_footprint_data_loading_failed && !showClusteringNoDataFound">
            <span class="visually-hidden">Loading...</span>
          </div>
          <div *ngIf="showClusteringPlot">
            <plotly-plot [data]="clusterFootprintGraph.data" [layout]="clusterFootprintGraph.layout"></plotly-plot>
          </div>
        </div>
  
  
  
      </div>
  
  
    </div>